import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {merge} from 'rxjs';
import {filter, map, mergeMap} from 'rxjs/operators';

import {environment} from '~local/environments/environment';
import {Logger} from '~local/app/shared/services/logger.service';
import {I18nService} from '~local/app/shared/services/i18n.service';
import {Angulartics2GoogleAnalytics} from 'angulartics2';

const log = new Logger('App');

@Component({
    standalone: true,
    selector: 'app-root',
    template: `<router-outlet/>`,
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly titleService = inject(Title);
    private readonly translateService = inject(TranslateService);
    private readonly i18nService = inject(I18nService);
    // do not remove the analytics injection, even if the call in ngOnInit() is removed
    // this injection initializes page tracking through the router
    private readonly angulartics2GoogleAnalytics = inject(Angulartics2GoogleAnalytics);

    ngOnInit() {
        // Setup logger
        if (environment.production) {
            Logger.enableProductionMode();
        }

        log.debug('init');

        this.angulartics2GoogleAnalytics.eventTrack(environment.version, {category: 'App initialized'});

        // Setup translations
        this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);

        const onNavigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd));

        // Change page title on navigation or language change, based on route data
        merge(this.translateService.onLangChange, onNavigationEnd)
            .pipe(
                map(() => {
                    let route = this.activatedRoute;
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                filter(route => route.outlet === 'primary'),
                mergeMap(route => route.data)
            )
            .subscribe(event => {
                let title = event['title'];
                if (title) {
                    title = 'MENU.' + title;
                    this.titleService.setTitle(this.translateService.instant(title));
                }
            });
    }

}
